export default __webpack_public_path__ + "static/media/data-management.0106b449.png";